import Main from '../../views/main'
import {ParentView} from '@/ladmin'

export default [
  {
    path: '/parkControl',
    name: 'parkControl',
    component: Main,
    meta: {
      disabled: true,
      label: '园区管理'
    },
    children: [
      {
        name: 'parkList',
        path: 'parkList',
        component: () => import(/* webpackChunkName: "reservation" */ '@/views/Park/parkList'),
        meta: {
          label: '园区管理',
        },
        children: [
        ]
      },
      {
        name: 'parkListParent',
        path: 'parkListParent',
        component: ParentView,
        meta: {
          label: '园区管理'
        },
        redirect: {name: 'parkList'},
        children: [
          {
            name: 'newPark',
            path: 'newPark',
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/Park/parkForm'),
            meta: {
              label: '新增园区'
            }
          },
          {
            name: 'parkDetailsBox',
            path: 'parkDetails',
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/Park/parkDetailsBox'),
            meta: {
              label: '园区详情'
            }
          }
        ]
      },
      {
        name: 'controllerList',
        path: 'controllerList',
        component: () => import(/* webpackChunkName: "reservation" */ '@/views/Park/controllerList'),
        meta: {
          label: '卡口管理',
        },
        children: [
        ]
      },
      {
        name: 'controllerListParent',
        path: 'controllerListParent',
        component: ParentView,
        meta: {
          label: '卡口管理'
        },
        redirect: {name: 'controllerList'},
        children: [
          {
            name: 'newController',
            path: 'newController',
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/Park/controllerForm'),
            meta: {
              label: '新增卡口'
            }
          },
          {
            name: 'controllerDetailsBox',
            path: 'controllerDetails',
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/Park/controllerDetailsBox'),
            meta: {
              label: '卡口详情'
            }
          }
        ]
      },
      {
        name: 'iotServiceList',
        path: 'iotServiceList',
        component: () => import(/* webpackChunkName: "reservation" */ '@/views/WS/Service/serviceList'),
        meta: {
          label: '硬件服务',
        },
        children: [
        ]
      },
      {
        name: 'iotServiceListParent',
        path: 'iotServiceListParent',
        component: ParentView,
        meta: {
          label: '硬件服务'
        },
        redirect: {name: 'iotServiceList'},
        children: [
          {
            name: 'newIotService',
            path: 'newIotService',
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/WS/Service/serviceForm'),
            meta: {
              label: '新增硬件服务'
            }
          },
          {
            name: 'iotServiceDetailBox',
            path: 'iotServiceDetailBox',
            component: () => import('@/views/WS/Service/serviceDetailBox'),
            meta: {
              label: '硬件服务详情'
            }
          },
        ]
      },
      {
        name: 'deviceList',
        path: 'deviceList',
        component: () => import('@/views/WS/Device/deviceList'),
        meta: {
          label: '控制器管理',
        },
        children: [
        ]
      },
      {
        name: 'deviceListParent',
        path: 'deviceListParent',
        component: ParentView,
        meta: {
          label: '控制器管理'
        },
        redirect: {name: 'deviceList'},
        children: [
          {
            name: 'newIotDevice',
            path: 'newIotDevice',
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/WS/Device/deviceForm'),
            meta: {
              label: '新增控制器'
            }
          },
          {
            name: 'deviceDetailBox',
            path: 'deviceDetailBox',
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/WS/Device/deviceDetailBox'),
            meta: {
              label: '控制器详情'
            }
          },
        ]
      },
      {
        name: 'packageList',
        path: 'packageList',
        component: () => import('@/views/WS/Package/packageList'),
        meta: {
          label: '硬件程序包管理',
        },
        children: [
        ]
      },
      {
        name: 'packageListParent',
        path: 'packageListParent',
        component: ParentView,
        meta: {
          label: '硬件程序包管理'
        },
        redirect: {name: 'packageList'},
        children: [
          {
            name: 'newIotPackage',
            path: 'newIotPackage',
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/WS/Package/packageForm'),
            meta: {
              label: '新增硬件程序包'
            }
          },
          {
            name: 'packageDetailBox',
            path: 'packageDetailBox',
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/WS/Package/packageDetailBox'),
            meta: {
              label: '程序包详情'
            }
          },
        ]
      },
    ]
  }
]
